import React from "react";

function CloseCircleIcon() {
  return (
    <span className="anticon anticon-closeCricle">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
      >
        <g fill="currentColor" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="currentColor" transform="translate(-917 -2122)">
            <g transform="translate(302 1955)">
              <g transform="translate(594 37)">
                <g transform="translate(21 113)">
                  <g transform="translate(0 17)">
                    <path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 2a9 9 0 100 18 9 9 0 000-18zm3.293 4.293l1.414 1.414L12.414 11l3.293 3.293-1.414 1.414L11 12.414l-3.293 3.293-1.414-1.414L9.586 11 6.293 7.707l1.414-1.414L11 9.586l3.293-3.293z"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default CloseCircleIcon;
